import React, {useState, useEffect} from 'react'
import { Link, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import {setToken as _setToken} from '../../apis/Tools';
import {Input, Button, Select, Alert, message as antMessage, Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import Label from '@app/components/common/Label';
import authAction from '@app/redux/auth/actions';
import profileAction from '@app/redux/profile/actions';
import SignInStyleWrapper from './styles';
import {login, getAllCompanies} from '../../apis/AuthApi';
import userRoles from '@app/constants/userRoles';
import Errors from '@app/components/Errors';
import {MenuFoldOutlined, MenuUnfoldOutlined, CaretDownOutlined } from '@ant-design/icons';
import O2MLogo from '@app/assets/images/O2M-Logo.png'; 
// import ReCAPTCHA from "react-google-recaptcha";

const SignIn = () => {
    let navigate = useNavigate();
    const dispatch = useDispatch();
    const authInfo = useSelector((state) => state.Auth);

    const [redirectToReferrer, setRedirectToReferrer] = React.useState(false);
    const [form, setForm] = React.useState({});
    const [token, setToken] = React.useState(true);
    const [isLoading, setIsLoading] = React.useState(false);
    // const [token, setToken] = React.useState( process.env.REACT_APP_ENV === 'dev');
    const [REACT_APP_ENV] = React.useState(process.env.REACT_APP_ENV);
    const [selectedCompany, setSelectedCompany] = useState('1');
    const [companies, setCompanies] = useState([]);

    useEffect(() => {
        const fetchCompanies = async () => {
          try {
            const response = await getAllCompanies();
            
            if (response.ok && response.payload.length > 0) {
                const formattedCompanies = response.payload.map(company => ({
                    value: company.id, // Usamos el ID interno como valor
                    label: company.name, // Mostramos el nombre
                }));
              
                setCompanies(formattedCompanies);
                setSelectedCompany(formattedCompanies[0].value); // Selecciona la primera por defecto
                setForm({...form, company:formattedCompanies[0].value});
            }
          } catch (error) {
            console.error("Error cargando compañías:", error);
          } finally {
          }
        };
    
        fetchCompanies();
    }, []);

    React.useEffect(() => {
        if (authInfo.isLoggedIn) {
            setRedirectToReferrer(true);
        }
    }, [authInfo.isLoggedIn]);

    async function handleLogin(e) {
        e?.preventDefault?.();
        setIsLoading(true);
        try {
            const dataToSend = {
                ...form,
                company: Number(form.company) 
            };
            const response = await login(dataToSend);
            if (response.ok) {
                const companySelected = companies.find(c => c.value === dataToSend.company);
                const userData = {
                    ...response.payload.user, 
                    companyName: companySelected?.label || ''
                };
                _setToken(response.payload.token, {...response.payload, user: userData});
                setToken(response.payload.token, {...response.payload});
                dispatch(authAction.login(response.payload));
                
                // Mostrar advertencias de suscripción o empleados si existen
                if (response.payload.subscription_warning) {
                    antMessage.warning(response.payload.subscription_warning, 10);
                }
                if (response.payload.employees_warning) {
                    antMessage.warning(response.payload.employees_warning, 10);
                }
            }
        } catch (error) {
            console.error('Error during login:', error);
            antMessage.error('Error al iniciar sesión. Por favor intenta de nuevo.');
        } finally {
            setIsLoading(false);
        }
    }

    const handleOnChangeCaptcha = (token) => {
        setForm({...form, token});
        setToken(true);
    }

    if (redirectToReferrer) {
        return navigate("/home");
        if(authInfo.currentUser.role_id === userRoles.admin || authInfo.currentUser.role_id === userRoles.user){
            return navigate("/home");
        }
        // if(authInfo.currentUser.role_id === userRoles.user){
        //     return navigate("/app");
        // }
    }

    
    const handleCompanyChange = (value) => {
        const companySelected = companies.find(c => c.value === value);
        setSelectedCompany(value);
        debugger;
        setForm({...form, company:value});

    };

    return <>
        <SignInStyleWrapper>
            <div className="isoLoginContentWrapper">
                <div className="isoLoginContent">
                    <div className="isoLogoWrapper">
                        <Link to="/dashboard">
                            {/* <img alt="altregy" src={"https://altregy.com/img/Logo/LOGO-ALTREGY@2x.png"} style={{maxWidth: 200}}/> */}
                            <img alt="o2m" src={O2MLogo} style={{maxWidth: 350}}/>
                        </Link>
                    </div>
                    <div className="isoSignInForm">
                        <form onSubmit={handleLogin}>
                            <Errors/>
                            <br />

                            <div className="isoInputWrapper">
                                <Label require="true">Correo electrónico</Label>
                                <Input size="large" autoComplete="true" onChange={(event)=>{setForm({...form, email: event.target.value})}} />
                            </div>

                            <div className="isoInputWrapper">
                                <Label require="true">Contraseña</Label>
                                <Input
                                    size="large"
                                    type="password"
                                    autoComplete="false"
                                    onPressEnter={handleLogin}
                                    onChange={(event)=>{setForm({...form, password: event.target.value})}}
                                />
                            </div>

                            <div className="isoInputWrapper">
                                <Label require="true">Compañia</Label>
                                <br/>
                                <Select
                                    size="large"
                                    value={selectedCompany}
                                    onChange={handleCompanyChange}
                                    options={companies}
                                    suffixIcon={<CaretDownOutlined />}
                                />
                            </div>

                            {/* {
                                REACT_APP_ENV !== 'dev' && 
                                <div className="isoInputWrapper isoLeftRightComponent">
                                    <ReCAPTCHA sitekey="6Lc8ivcjAAAAAD3zykL8hvx0gKfbaN5Dl6JCZBTZ" onChange={handleOnChangeCaptcha} />
                                </div>
                            } */}

                            <div className="isoInputWrapper isoLeftRightComponent">
                                <Button 
                                    type="primary" 
                                    htmlType="submit"
                                    disabled={!token || isLoading}
                                    loading={isLoading}
                                >
                                    {isLoading ? 'Validando...' : 'Ingresar'}
                                </Button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </SignInStyleWrapper>
    </>
}

export default SignIn;